export class HubVisitorDataSource {
    public place = 'google';
    public event: string;
    // public isAreaBusiness = false;
    public businessType = 'normal';
    public placeImagesShownCount = 5;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/models/hub/hub.visitor.data.source.ts